<template>
	<Modal style="background-color: white; top: 30px">
		<div class="instruction">
			<div class="heading">
				<i
					class="fas fa-angle-left"
					@click="$emit('previous')"
				/>
				<h1>{{ $t('antesDeComecarmos') }}</h1>
			</div>
			<div>
				<p>
					{{ $t('verifiqueAsColunas') }}
				</p>
				<a @click="downloadExemplo">{{ $t('baixeArquivoModelo') }}</a>
			</div>

			<table cellspacing="0">
				<thead>
					<tr>
						<th
							v-for="(coluna, index) in colunas"
							:key="coluna.nome + index"
						>
							{{ coluna.nome }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td
							v-for="(coluna, index) in colunas"
							:key="coluna.exemplo + index"
						>
							{{ coluna.exemplo }}
						</td>
					</tr>
				</tbody>
			</table>

			<div class="instruction-container">
				<p
					v-for="coluna in colunas"
					:key="coluna.key"
					style="padding: 0.15rem 0"
				>
					{{ $t('column') }}
					<strong>{{ `${coluna.nome}  ${coluna.unidade || ''}` }}</strong>
					{{ coluna.descricao.replace('Coluna', '') }}
					{{ $t('emFormato') }}
					<strong>{{ coluna.formato === 'number' ? 'Número' : 'Texto' }}</strong>
				</p>
			</div>
			<div class="flex 2-full justify-between items-center">
				<Checkbox
					v-model="conscent"
					:label="$t('naoMostrarNovamente')"
				/>
				<Button
					:label="$t('continue')"
					style="width: fit-content; float: right"
					@click="$emit('continue')"
				/>
			</div>
		</div>
	</Modal>
</template>

<script setup>
import { useLocalStorage } from '@vueuse/core'
import { toRefs } from 'vue'
import Button from '../Button/Button.vue'
import Checkbox from '../Checkbox/Checkbox.vue'
import Modal from '../Modal/Modal.vue'

import download from 'downloadjs'

const props = defineProps({
	colunas: {
		type: Array,
		defualt: () => [],
	},
	chave: { type: String, default: 'default' },
})

const { chave } = toRefs(props)

const conscent = useLocalStorage(`conscent-${chave.value}`, false)

const downloadExemplo = () => {
	const items = Array(5).fill(props.colunas.map((m) => m.exemplo))

	const header = props.colunas.map((m) => m.nome.normalize('NFD').replace(/[^a-zA-Z\s]/g, ''))
	const csv = [
		header, // header row first
		...items,
	]
		.map((m) => m.join(';'))
		.join('\r\n')

	download(csv, 'Exemplo Medição.csv', 'text/csv')
}
</script>

<style scoped>
table {
	white-space: nowrap;
}

.instruction-container {
	background-color: #f1f1f1;
	padding: 1rem;
	border: 1.5px solid #737576;
	border-radius: 5px;
}

.heading {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
}

thead tr {
	background-color: #ccd7df;
}

th {
	color: #01395e;
}

th,
td {
	padding: 0 0.5rem;
}

td {
	color: #272728;
	font-size: 0.9rem;
}

i {
	font-size: 1.3rem;
	cursor: pointer;
}

h1,
a,
p {
	margin: 0;
}

.instruction {
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
}
</style>
